<script setup lang="ts">
import OneButton from '@/common/components/molecules/button/OneButton.vue';
import TagItem from '@/common/components/molecules/tag/TagItem.vue';
import MenuSearchResultItem from './MenuSearchResultItem.vue';

import { setup } from './menuSearchResult.setup';

const {
  t,
  groupedSearchResults,
  isDashboardListError,
  getDashboardType,
  handleClick,
  handleClickFavorite,
} = setup();
</script>

<template>
  <section class="menu-search-result-group">
    <div
      v-for="group in groupedSearchResults"
      :key="group.depthTitle"
      class="menu-search-result-group__section"
    >
      <h3 class="menu-search-result-group__title">{{ group.depthTitle }}</h3>
      <ul class="menu-search-result-group__items">
        <menu-search-result-item
          v-for="item in group.items"
          :id="item.id"
          :key="item.id"
          :icon="item.icon"
          :featured-icon="item.featuredIcon"
          :title="item.title"
          :path="item.path"
          @on-click="() => handleClick(item)"
        >
          <template #subTitle>
            <span
              v-if="item.type === 'menu'"
              class="menu-sub-title"
              >{{ item.subTitle }}</span
            >
            <tag-item
              v-else
              html-type="span"
              size="small"
              :class="`dashboard-sub-title dashboard-sub-title--${item.dashboardType || 'custom'}`"
              >{{ getDashboardType(item.dashboardType || 'custom') }}</tag-item
            >
          </template>
          <template #suffix>
            <one-button
              v-if="item.type === 'dashboard' && item.favoriteId"
              size="small"
              type="icon"
              class="menu-search-result-item__suffix"
              @click.stop="
                handleClickFavorite({ dashboardId: item.dashboardId, favoriteId: item.favoriteId })
              "
            >
              <ev-icon icon="icon-fill-star" />
            </one-button>
          </template>
        </menu-search-result-item>
      </ul>
    </div>
    <div
      v-if="isDashboardListError"
      class="menu-search-result-group__dashboard-error"
    >
      <p>{{ t('MESSAGE.GNB_SEARCH_ERROR_MESSAGE') }}</p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.menu-search-result-group {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 220px;

  &__section {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    height: 32px;
    padding: 16px 8px 4px;
    font-weight: 500;
    color: var(--color-gray-03-09);

    @include typography('body-2');
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__dashboard-error {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    align-self: stretch;
    justify-content: center;
    padding: 16px 0;
    background-color: var(--color-gray-07-01);
    color: var(--color-gray-02-10);
  }
}
</style>
